import { render, staticRenderFns } from "./TheMessagesMenu.vue?vue&type=template&id=9d1cb110&scoped=true"
import script from "./TheMessagesMenu.vue?vue&type=script&lang=js"
export * from "./TheMessagesMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMessagesMenu.vue?vue&type=style&index=0&id=9d1cb110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1cb110",
  null
  
)

export default component.exports